/**
 * Kahla v2 — cerrar el desplegable de facetas cuando el foco se va.
 *
 * Lo único que hace, y a propósito: el resto del teclado ya funciona en
 * Horizon y no hay que tocarlo. Medido en el tema dev con teclado:
 *
 *   Tab llega al `summary` con anillo visible       ✓
 *   Enter abre el panel                              ✓
 *   Tab entra en las opciones                        ✓
 *   Escape cierra y devuelve el foco al `summary`    ✓
 *   Tab más allá de la última opción sale del panel  ✓
 *   …pero EL PANEL SE QUEDA ABIERTO                  ✗  <- esto
 *
 * O sea que tabulando se cruza el desplegable, se sigue hasta las
 * tarjetas de producto y el panel sigue flotando encima de la rejilla,
 * tapando justo lo que se está filtrando. Es el «el foco entra y sale
 * del desplegable» del criterio de cierre de KSD-34.
 *
 * Se resuelve con `focusin` delegado en el documento, no con `focusout`
 * en cada panel: Horizon vuelve a pintar las facetas al filtrar, así que
 * cualquier oyente colgado del propio panel se pierde en el repintado.
 * Delegar en el documento sobrevive.
 *
 * SÓLO la maqueta horizontal. Dentro del cajón de móvil las facetas son
 * un acordeón y varias abiertas a la vez es lo normal — cerrarlas ahí
 * pelearía con el patrón en vez de ayudar.
 */
(() => {
  const SELECTOR = '.facets--horizontal .facets__panel[open]';

  /** @param {Event} event */
  const closeIfOutside = (event) => {
    const target = /** @type {Node} */ (event.target);
    for (const panel of document.querySelectorAll(SELECTOR)) {
      // El `summary` es hijo del `details`, así que abrir con teclado o
      // con ratón no se autocierra: el foco cae dentro del propio panel.
      if (!panel.contains(target)) panel.removeAttribute('open');
    }
  };

  document.addEventListener('focusin', closeIfOutside);

  // Un clic en el vacío no siempre dispara `focusin` —pinchar sobre
  // texto plano no mueve el foco en todos los navegadores—, así que el
  // mismo criterio se aplica al puntero. En captura, para que corra
  // aunque algo detenga la propagación más abajo.
  document.addEventListener('pointerdown', closeIfOutside, true);
})();
